import { IActionFn } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';
import store from '@/store';

// 查询底材列表
export const queryBaseMatList: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setBaseMatList', { ...state.baseMatList, loading: true });
    const res = await $http.get('/v1/asset/material/basemat/list');
    commit('setBaseMatList', { data: res });
  } catch (e) {
    commit('setBaseMatList', { data: [] });
  }
};

// 查询底材详情
export const queryBaseMatDetail: IActionFn<IModuleState> = async ({ commit }, code) => {
  try {
    commit('setBaseMatDetail', { data: null, loading: true });
    const res = await $http.get(`/v1/asset/material/basemat/${code}/detail`);
    commit('setBaseMatDetail', { data: res });
  } catch (e) {
    commit('setBaseMatDetail', { data: null });
  }
};

// 添加底材
export const addBaseMat: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/asset/material/basemat/add', payload);
    store.commit('common/setToast', { visible: true, text: '添加成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 编辑底材
export const editBaseMat: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/asset/material/basemat/modify', payload);
    store.commit('common/setToast', { visible: true, text: '编辑成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 删除底材
export const deleteBaseMat: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/asset/material/basemat/delete', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};
